import {Component, Input} from '@angular/core';
import {BreadcrumbPage} from "@app/presentation/components/breadcrumb/breadcrumb-page";
import {routesNames} from "@app/app-routing.module";

@Component({
  selector: 'ep-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {

  defaultPages = {
    homePage: {
      pageNameKey: 'home',
      url: '/' + routesNames.home
    }
  }

  _pages: BreadcrumbPage[] = [];

  /**
   * The pages to be displayed in the breadcrumb
   * @param breadcrumbItems
   */
  @Input()
  set pages(breadcrumbItems: BreadcrumbPage[] | null) {
    if (breadcrumbItems) {
      this._pages = breadcrumbItems;
    }
  }

  /**
   * If you want to display the home screen in the breadcrumb
   */
  @Input() hasHomePage = true;

}
